module.exports = __webpack_public_path__ + "static/media/DWZ_02.53844518.jpg";